import Clients from "./clients.component.vue";

export default Clients;
